// extracted by mini-css-extract-plugin
export var productImage = "_r6-1";
export var viewLink = "_r6-2";
export var wishlistItem = "_r6-0";